import React from 'react';
import { signOut } from '../lib/auth';

const ResourceSubscriptionExpired: React.FC = () => {
  const handleReturnToLogin = async () => {
    try {
      console.log('🚪 Subscription expired - signing out...');
      
      // Use the comprehensive sign out function
      const { error } = await signOut();
      
      if (error) {
        console.error('Sign out error:', error);
      }
      
      // Redirect to login
      window.location.href = '/login';
    } catch (error) {
      console.error('Error signing out:', error);
      // If sign out fails, just redirect anyway
      window.location.href = '/login';
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-orange-100 mb-4">
            <svg className="h-6 w-6 text-orange-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          
          <h1 className="text-xl font-semibold text-gray-900 mb-2">
            Subscription Expired
          </h1>
          
          <p className="text-gray-600 mb-6">
            Your subscription has expired. Please contact your administrator to renew your access.
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={handleReturnToLogin}
            className="w-full bg-orange-600 text-white py-3 px-4 rounded-xl font-semibold hover:bg-orange-700 transition-colors duration-200"
          >
            Return to Login
          </button>
          
          <button
            onClick={() => window.location.reload()}
            className="w-full bg-gray-100 text-gray-700 py-3 px-4 rounded-xl font-semibold hover:bg-gray-200 transition-colors duration-200"
          >
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResourceSubscriptionExpired; 